import axios, { baseURL } from '@axios'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getShop(ctx, { id }) {
      const userData = getUserData()
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Shop/GetById`, {
            params: {
              shopId: id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editShop(ctx, shopData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Shop/AddOrUdpate`, shopData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadFile(ctx, formData) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Upload/Upload`, formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userData.token}`,
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadFileMultiple(ctx, formData) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Upload/MultiUpload/multiple`, formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userData.token}`,
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProducts(ctx, queryParams) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        const body = {
          pagination: {
            total: 0,
            current: 0,
            pageSize: 0,
            // current: queryParams.page,
            // pageSize: queryParams.perPage,
          },
          search: {
            name: '',
            // name: '',
            startPrice: null,
            endPrice: null,
            shopId: userData.shopId,
            categoryId: null,
            hasOptions: null,
            isVisibleIndividually: null,
            isFeatured: null,
            isAllowToOrder: null,
            isPublished: null,
            isChecking: null,
            isViolation: null,
            sku: null,
            categoryIds: [

            ],
            includeSubCategories: true,
            outOfStock: null,
          },
          sort: {
            predicate: 'created_date',
            // predicate: queryParams.sortBy,
            reverse: true,
          },
        }

        axios
          .post(`${baseURL}/api/Product/GetList`, body, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postProvince() {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Province/GetProvinceList`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',

            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postDistrict(ctx, province) {
      console.log('postDistrict', province)
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/District/GetDistrictList?provinceCode=${province}`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',

            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    postSubDistrict(ctx, payload) {
      console.log('postDistrict', payload)
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SubDistrict/GetSubDistrictList?provinceCode=${payload.province}&districtCode=${payload.district}`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',

            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
